import React from 'react';
import { GiTennisCourt } from 'react-icons/gi';
import { MdSportsTennis } from 'react-icons/md';
import { Player } from '../types';

interface ActionButtonsProps {
  currentUser: Player | null;
  onProposeGame: () => void;
  onAddAvailability: () => void;
}

export default function ActionButtons({
  currentUser,
  onProposeGame,
  onAddAvailability
}: ActionButtonsProps) {
  return (
    <div className="flex flex-col sm:flex-row gap-4 items-center justify-center sm:justify-start">
      <div className="flex flex-col sm:flex-row gap-3 w-full sm:w-auto">
        <button
          onClick={onAddAvailability}
          className="availability-button flex items-center justify-center gap-2 bg-blue-600 text-white px-6 py-3 rounded-xl hover:bg-blue-700 transition-all duration-200 shadow-md hover:shadow-lg transform hover:scale-105 font-medium"
        >
          <MdSportsTennis className="w-5 h-5" />
          Quero Jogar
        </button>

        <button
          onClick={onProposeGame}
          className="propose-game-button flex items-center justify-center gap-2 bg-green-600 text-white px-6 py-3 rounded-xl hover:bg-green-700 transition-all duration-200 shadow-md hover:shadow-lg transform hover:scale-105 font-medium"
        >
          <GiTennisCourt className="w-5 h-5" />
          Propor Jogo
        </button>
      </div>
    </div>
  );
}